import { Link } from '@tanstack/react-router';

interface Props {
  /** Context-specific line, e.g. why sign-in unlocks this screen. */
  message?: string;
  title?: string;
  /** Drop the full-height centering when embedding inside another layout. */
  inline?: boolean;
}

/**
 * Neutral "please sign in to continue" screen — shown when content reads are denied for
 * anonymous users (Phase 0 auth-required rules). Deliberately calm, NOT the red error card.
 */
export function AuthRequired({
  message = 'Đăng nhập để xem nội dung và lưu tiến độ học của bạn.',
  title = 'Đăng nhập để tiếp tục',
  inline = false,
}: Props) {
  return (
    <div
      className={
        inline
          ? 'flex items-center justify-center p-6'
          : 'flex min-h-[60vh] items-center justify-center p-6'
      }
    >
      <div className="w-full max-w-sm rounded-2xl border border-border bg-surface p-6 text-center">
        <h2 className="text-[17px] font-bold text-ink-1">{title}</h2>
        <p className="mt-2 text-[14px] leading-snug text-ink-2">{message}</p>
        <div className="mt-5 flex flex-col gap-2">
          <Link
            to="/login"
            className="rounded-xl bg-[var(--brand)] py-2.5 text-[14px] font-semibold text-white"
          >
            Đăng nhập
          </Link>
          <Link
            to="/signup"
            className="rounded-xl border border-border bg-transparent py-2.5 text-[14px] font-medium text-ink-2"
          >
            Tạo tài khoản
          </Link>
        </div>
      </div>
    </div>
  );
}
